import { 
  RECEIVE_USER_INFO, 
  RECEIVE_MASTERS, 
  RECEIVE_UPDATED_MASTER,
  RECEIVE_MY_STUDENTS, 
  RECEIVE_STUDENTS, 
  RECEIVE_UPDATED_STUDENT, 
  ADD_COURSES_TO_MASTER,
  RECEIVE_SEARCH_RESULTS, 
  RECEIVE_SEARCH_ERRORS,  
  ENROLL_STUDENT_IN_COURSE,
  RECEIVE_ENROLLMENT_ERRORS, 
  RECEIVE_UPDATED_PROFILE, 
  RECEIVE_CREDITS
} from '../actions/user_actions';

const initialState = {
  user: undefined, 
  masters: undefined, 
  updatedMaster: undefined,
  students: [], 
  myStudents: undefined, 
  updatedStudent: undefined, 
  searchErrors: null, 
  errors: null, 
  profile: null
};

const UserReducer = (state = initialState, action) => {
  switch(action.type) {
    case RECEIVE_USER_INFO:
      return { 
        ...state, 
        updated: action.updated.data 
      };

    case RECEIVE_MASTERS:
      return { 
        ...state, 
        masters: action.masters.data 
      };

    case RECEIVE_UPDATED_MASTER:
      return { 
        ...state, 
        updatedMaster: action.updatedMaster.data 
      };

    case RECEIVE_MY_STUDENTS:
      return { 
        ...state, 
        myStudents: action.myStudents.data 
      };

    case RECEIVE_STUDENTS:
      return { 
        ...state, 
        students: action.students.data 
      };

    case RECEIVE_UPDATED_STUDENT:
      return { 
        ...state, 
        updatedStudent: action.updatedStudent.data 
      };

    case ADD_COURSES_TO_MASTER:
      return { 
        ...state, 
        masters: state.masters?.map(master => 
          master._id === action.user._id ? action.user : master
        ) 
      };

    case RECEIVE_SEARCH_RESULTS:
      return {
        ...state,
        students: action.students,
        searchErrors: null // Clear previous errors
      };

    case RECEIVE_SEARCH_ERRORS:
      return {
        ...state,
        students: [], // Clear students if there's an error
        searchErrors: action.errors
      };

    case ENROLL_STUDENT_IN_COURSE:
      return {
        ...state,
        students: state.students.map(student =>
          student._id === action.student._id ? action.student : student
        )
      };

    case RECEIVE_ENROLLMENT_ERRORS:
      return { 
        ...state, 
        errors: action.errors 
      };

    case RECEIVE_UPDATED_PROFILE:
      return {
        ...state,
        profile: { 
          ...state.profile, 
          ...action.profile // Merge new profile updates instead of replacing
        }
      };

    case RECEIVE_CREDITS:
      return {
        ...state,
        profile: { 
          ...state.profile, 
          credits: action.profile.credits // Only update credits field
        }
      };

    default:
      return state;
  }
};

export default UserReducer;
